import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { SCUILoadingLinear } from '../../../../atomic/atoms';
import { SCUIContent } from '../../../../atomic/organisms';
import { SCUIBreadCrumb } from '../../../../atomic/molecules';
import { CargoSelection } from '../CargoSelection/CargoSelection';
import { CargoAdmission } from '../CargoAdmission/CargoAdmission';

import { useStorePickupPackageContext } from '../../context/StorePickupPackageContext';
import { SPP } from '../../storePickupPackage.classes';

export const StorePickupPackageLayout = () => {
    const {
        isLoading,
        isCargoCompanySelected,
        setCargoCompany,
        setIsCargoCompanySelected,
        setPackageList,
        setIsLoading,
        setDamagedRows,
        setScannedRows,
        setDPackageCargoShipmentCode,
    } = useStorePickupPackageContext();
    const { t } = useTranslation();

    const clearPage = () => {
        setCargoCompany(undefined);
        setIsCargoCompanySelected(false);
        setPackageList(null);
        setIsLoading(false);
        setDamagedRows([]);
        setScannedRows([]);
        setDPackageCargoShipmentCode('');
    };

    return (
        <SCUIContent className={SPP.page}>
            <Box className={SPP.root}>
                <Box className={SPP.loading}>
                    <SCUILoadingLinear display={isLoading} />
                </Box>
                <Box className={SPP.breadcrumb}>
                    <SCUIBreadCrumb
                        title={t('storePickupPackageAdmission.title')}
                        componentLink={'/store-pickup-package-admission'}
                        onClick={clearPage}
                    />
                </Box>
                <Box className={SPP.body} sx={{ padding: '16px' }}>
                    {isCargoCompanySelected ? <CargoAdmission /> : <CargoSelection />}
                </Box>
            </Box>
        </SCUIContent>
    );
};
